function showGdprInfo(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    const info_class = 'newsletterSubscription__gdprInfo'
    const info = e.target.closest('.frm_fields_container').getElementsByClassName(info_class)[0];
    info.classList.remove(`${info_class}--hidden`);
    info.classList.add(`${info_class}--visible`);
}

const hideGdprInfo = function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    const info_class = 'newsletterSubscription__gdprInfo'
    const info = e.target.closest(`.${info_class}`);
    info.classList.remove(`${info_class}--visible`);
    info.classList.add(`${info_class}--hidden`);
}

const load_scripts = function() {
    return {
        showGdprInfo,
        hideGdprInfo,
    }
}

export {load_scripts}